import { render, staticRenderFns } from "./ProductCarousel.vue?vue&type=template&id=5300c97c&"
import script from "./ProductCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports